import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('capacityQuantityService', capacityQuantityService);

    function capacityQuantityService(dashboardService) {
        var CAPACITY_FORMATS_ENUM = dashboardService.ENUMS.CAPACITY_FORMATS;
        var targetFormat = dashboardService.settings.capacityFormat;

        function format(amount, type) {
            return formatTo(amount, type, targetFormat);
        }

        function formatTo(amount, type, target) {
            var formattedAmount = null;
            if (type == target) {
                formattedAmount = amount;
            } else if (
                type == CAPACITY_FORMATS_ENUM.KILO &&
                target == CAPACITY_FORMATS_ENUM.MEGA
            ) {
                formattedAmount = amount / 1000;
            } else if (
                type == CAPACITY_FORMATS_ENUM.MEGA &&
                target == CAPACITY_FORMATS_ENUM.KILO
            ) {
                formattedAmount = amount * 1000;
            }
            return {
                amount: formattedAmount,
                format: target
            };
        }

        return {
            format: format,
            formatTo: formatTo
        };
    }
})();
